module.exports = __webpack_public_path__ + "img/dots.ece5706c.png";